import React, { useEffect, useState, useRef } from "react";
import styles from "./HeroSection.module.css";
import loaderStyles from "./Loader.module.css";

const HeroSection = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [opacity, setOpacity] = useState(1);
  const logoImgRef = useRef(null);
  const logoDisplayRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    // Handle video loading
    const videoElement = videoRef.current;
    if (videoElement) {
      // Try to play the video immediately (might be blocked)
      const playPromise = videoElement.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Video started playing successfully
            setIsLoading(false);
          })
          .catch((error) => {
            // Autoplay was blocked or error occurred
            console.log("Video autoplay was blocked:", error);
            // Show play button or fallback content
            setIsLoading(false);
          });
      }
    }

    // Fade out effect on scroll (works on all browsers)
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const fadeStart = 50;
      const fadeEnd = 350;
      const newOpacity = Math.max(
        1 - (scrollY - fadeStart) / (fadeEnd - fadeStart),
        0
      );
      setOpacity(newOpacity);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!isLoading) {
      // Use timeouts to sequence the animations
      setTimeout(() => {
        if (logoDisplayRef.current) {
          logoDisplayRef.current.classList.add(styles.visible);
        }
      }, 1500);

      setTimeout(() => {
        if (logoImgRef.current) {
          logoImgRef.current.classList.add(styles.visible);
        }
      }, 2000);
    }
  }, [isLoading]);

  const handleVideoCanPlay = () => {
    setIsLoading(false);
  };

  return (
    <>
      {/* Full-Screen Loader */}
      {isLoading && (
        <div className={loaderStyles.loaderContainer}>
          <div className={loaderStyles.loader}></div>
        </div>
      )}

      {/* Show content */}
      <div
        className={`${styles.container} ${
          !isLoading ? loaderStyles.containerFadeIn : ""
        }`}
        style={{
          visibility: isLoading ? "hidden" : "visible",
          opacity: !isLoading ? 1 : 0,
          transition: "opacity 0.8s ease-in-out",
        }}
      >
        <video
          ref={videoRef}
          src="./assets/railway.mp4"
          muted
          playsInline
          autoPlay
          loop
          onCanPlay={handleVideoCanPlay}
          poster="./assets/video-poster.jpg"
          style={{ opacity }}
          className={styles.videoElement}
        ></video>

        <div className={styles.logoContainer} style={{ opacity }}>
          <img
            ref={logoImgRef}
            src="/assets/logo.png"
            alt="Logo"
            className={styles.logoImg}
          />
          <div className={styles.leftRod}></div>
          <div className={styles.rightRod}></div>
          <div ref={logoDisplayRef} className={styles.logoDisplay}>
            SPACE.<span>LABS</span>
          </div>
          <div className={styles.bottomRod}></div>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
